import React from "react";
import { Modal, Button } from "react-bootstrap";
const VideoExpanded = ({ src, videoShow, setVideoShow }) => {
  const handleClose = () => setVideoShow(false);
  const handleShow = () => setVideoShow(true);
  return (
 
    <Modal
      className="modal fade  videoModal"
      show={videoShow}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="p-1">
        <button
          type="button"
          className="closeVideo"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true" onClick={handleClose}>
            &times;
          </span>
        </button>

        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            className="embed-responsive-item"
            src={src}
            id="video"
            allowscriptaccess="always"
            allow="autoplay"
          ></iframe>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoExpanded;
